module.exports = __webpack_public_path__ + "static/media/test19.08ca044c.jpg";